import LoaderGlobal from './LoaderGlobal';

export default LoaderGlobal;